(function () {
    angular
        .module('dashboard')
        .component('campaignWizardHeader',
            {
                templateUrl: 'components/campaigns/wizard/header/campaign-wizard-header.e6907404.html',
                bindings: {
                    headerState: "=",
                },
                controller: [
                    '$scope',
                    '$state',
                    'PermissionService',
                    CampaignWizardHeaderController]
            });

    function CampaignWizardHeaderController(
        $scope,
        $state,
        PermissionService) {

        $scope.appendTemplateRequestParameters = function() {
            const user = $scope.getUserInformation();
            const fieldMappings = [
                ["FirstName", user.FirstName],
                ["LastName", user.LastName],
                ["EmailAddress", user.Email],
                ["MobileNumber", user.MobileNumber],
                ["StoreId", this.getStoreId()],
                ["StoreName", this.getStoreName()]
            ];

            let queryString = "";
            fieldMappings.forEach(f => {
                if (f[1]) {
                    queryString += `&${f[0]}=${f[1]}`;
                }
            })

            return queryString;
        }

        $scope.isInRestaurantContext = function() {
            return PermissionService.userContext.ContextType === "StoreContext";
        }

        $scope.getStoreName = function() {
            return PermissionService.userContext.StoreName;
        }

        $scope.getStoreId = function() {
            return PermissionService.userContext.StoreId;
        }

        $scope.getUserInformation = function() {
            return PermissionService.user;
        }

        $scope.openTemplateRequestForm = function () {
            window.open(
                `https://forms.yumbi.com/yumbi/form/StoreCampaignTemplateRequestForm/formperma/oMhWApa7wdwyXLCh-n5mmxtCaLAb7ztmScqxyhhZa_4?zf_rszfm=1${ this.appendTemplateRequestParameters() }`,
                "_blank");
        }

        this.navigateToTemplatesList = function () {
            const userContext = PermissionService.userContext;
            const params = { storeId: userContext.StoreId, brandId: userContext.BrandId };
            const brandCampaigns = "app.brandcampaigns";
            const storeCampaigns = "app.storecampaigns";
            if (PermissionService.userContext.isBrandContext()) {
                $state.go(brandCampaigns, params);
            } else if (PermissionService.userContext.isStoreContext()) {
                $state.go(storeCampaigns, params);
            }
        }
    }
})();
